import { createContext } from 'react'

export type SidebarType = {
  isOpen?: boolean
  onClose?: () => void
  onOpen?: () => void
}

const defaultValues = {
  isOpen: true,
  onClose: () => {},
  onOpen: () => {},
}

const SidebarContext = createContext<SidebarType>(defaultValues)

export default SidebarContext
